$(document).ready(function() {
  $('.kye-form-field-type').trigger('change');
  $(document).on('change', '.kye-form-field-type', function(event) {
    var selectedFieldType = $(this).val();
    var selectOptionsField = $(this).closest('.row').find('#add-meta-data-field');
    var metaDataFields = $(this).closest('.row').find('.meta-data-field');
   

    if (selectedFieldType !=='select') {
      selectOptionsField.addClass('hidden');
      metaDataFields.addClass('hidden');
    } else {
      metaDataFields.removeClass('hidden');
      selectOptionsField.removeClass('hidden');
    }
  });
});



$(document).on('click', '.remove-meta-data-field', function(e) {
  e.preventDefault();
  $(this).closest('.meta-data-field').remove();
});

$(document).on('click', '#add-meta-data-field', function(e) {
  e.preventDefault();
  var container = $(this).next('.meta-data-fields')
  var template = $(this).data('metaoption')
  container.append(template);
});

document.addEventListener("DOMContentLoaded", function () {
  function updateFieldPositions() {
    const fieldSections = document.querySelectorAll("#form-fields > section");
    fieldSections.forEach((field, index) => {
      const positionInput = field.querySelector(".field-position");
      if (positionInput) {
        positionInput.value = index + 1;
      }
    });
  }

  document.body.addEventListener("click", function (event) {
    if (event.target.matches(".add_form_fields") || event.target.closest(".add_form_fields")) {
      setTimeout(() => {
        updateFieldPositions();
      }, 0);
    }
  });

  document.body.addEventListener("click", function (event) {
    if (event.target.matches(".remove_fields") || event.target.closest(".remove_fields")) {
      event.preventDefault();
      const field = event.target.closest("section");
      if (field) {
        field.remove(); 
        updateFieldPositions();
      }
    }
  });

  updateFieldPositions();
});